import { customAxios } from './customAxios'
export function getApprovazioneADV(idPratica) {
  const config = {
    params: { idPratica: idPratica },
    headers: {
      Accept: '*/*',
      AuthToken: JSON.parse(localStorage.getItem('token')),
    },
  }
  const getApprovazioneADVRequest = customAxios
    .get(
      process.env.REACT_APP_BACKEND_HOST +
        `/` +
        process.env.REACT_APP_PATH_NEW_PREFIX +
        `/getApprovazioneADV?`,
      config,
    )
    .then(response => response.data.body)
  return getApprovazioneADVRequest
}
